import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { safeInternalPath } from '../../utils/safeRedirect';
import { track } from '../../utils/analytics';
import Loader from '../ui/Loader';

export default function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <Loader text="Проверяем сессию..." />;
    }

    if (!isAuthenticated) {
        const redirectPath = safeInternalPath(location.pathname);
        track('protected_route_blocked', { from_path: redirectPath });
        return <Navigate to={`/login?redirect=${encodeURIComponent(redirectPath)}`} replace />;
    }

    return children;
}
